import { ITheme } from "waapi/waap-ui/components/Theme/Theme.types.js";
import { useState } from "react";
import { useTheme } from "styled-components";
import { EyeBold } from "waapi/waap-ui/components/Iconsax/EyeBold.js";
import { EyeSlashLinear } from "waapi/waap-ui/components/Iconsax/EyeSlashLinear.js";
import { ICONSAX_SIZE } from "waapi/waap-ui/components/Iconsax/Iconsax.types.js";
import { BaseInput } from "../BaseInput/index.js";
import { BasePasswordInputProps } from "./types.js";

export const BasePasswordInput = (props: BasePasswordInputProps): JSX.Element => {
    const [showPassword, setShowPassword] = useState(false);
    const theme = useTheme() as ITheme;

    return (
        <BaseInput
            {...props}
            type={showPassword ? "text" : "password"}
            appendElements={
                showPassword ? (
                    <EyeSlashLinear
                        size={ICONSAX_SIZE.LARGE}
                        color={theme.grayscale[70]}
                        style={{ cursor: "pointer" }}
                        onClick={() => setShowPassword(!showPassword)}
                    />
                ) : (
                    <EyeBold
                        size={ICONSAX_SIZE.LARGE}
                        color={theme.grayscale[70]}
                        style={{ cursor: "pointer" }}
                        onClick={() => setShowPassword(!showPassword)}
                    />
                )
            }
        />
    );
};
